<template>
  <custom-select-multiple
    ref="selecteCus"
    v-show="cusListTotal.length > 1"
    v-loading="loading"
    v-bind="{...$attrs}"
    v-on="{...$listeners}"
    :options="options"
    :key-props="keyProps"
  >
  </custom-select-multiple>
</template>

<script>
  import CustomSelectMultiple from '@/air/components/custom-select-multiple/index';
  import { validatenull } from "@/util/validate";
  import { mapGetters } from 'vuex';
  export default {
    name: "SelectCus",
    components: {
      CustomSelectMultiple
    },
    props: {
      selected: {
        type: Array,
        default() {
          return []
        }
      }
    },
    mounted() {
      this.getCusList();
    },
    watch: {
      selected(val) {
        if(this.cusListTotal.length > 1) {
          this.$refs.selecteCus.handleBatchCommand(val)
        }
      }
    },
    data() {
      return {
        keyProps: {
          value: 'cusId',
          label: 'cusName'
        },
        options: []
      }
    },
    methods: {
      getCusList() {
       this.options = JSON.parse(JSON.stringify(this.cusListTotal));
      }
    },
    computed: {
      ...mapGetters(['cusListTotal'])
    }
  }
</script>

<style scoped>

</style>
